import React, { ReactNode } from 'react';
import cx from 'classnames';

interface ClassesModel {
  wrapper?: string;
  actions?: Record<string, boolean | undefined>;
}

type Props = {
  children?: ReactNode;
  enableSubTitle?: boolean;
  subTitle?: string | ReactNode;
  title: string;
  classes?: ClassesModel;
  isShowActions?: boolean;
};

export default function BaseTableHeader(props: Props) {
  const {
    title,
    enableSubTitle,
    children,
    subTitle,
    classes,
    isShowActions = true,
  } = props;

  return (
    <div className={cx('page-head', classes?.wrapper)}>
      <div className="page-head__left">
        <div className="page-head__title">
          <div className="text-uppercase">{title}</div>
          {enableSubTitle && (
            <div className="page-head__subtitle">{subTitle}</div>
          )}
        </div>
      </div>

      {children && isShowActions && (
        <div className={cx('page-head__actions', classes?.actions)}>
          {children}
        </div>
      )}
    </div>
  );
}
